/** Stable equality for settings form snapshots (order-sensitive JSON). */
export function settingsValuesEqual(a: unknown, b: unknown): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}
